export const normalizeTypeaheadText = (value = '') =>
  String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()

const getOptionLabel = (option, labelKey) => {
  if (typeof labelKey === 'function') {
    return labelKey(option)
  }

  return option?.[labelKey] || ''
}

export const createSelectedOptionAwareFilter = (labelKey) => (option, props = {}) => {
  const searchText = normalizeTypeaheadText(props.text)
  const selectedOptions = Array.isArray(props.selected) ? props.selected : []
  const isShowingSelectedOption = selectedOptions.some(
    (selectedOption) => normalizeTypeaheadText(getOptionLabel(selectedOption, labelKey)) === searchText
  )

  if (!searchText || isShowingSelectedOption) {
    return true
  }

  return normalizeTypeaheadText(getOptionLabel(option, labelKey)).includes(searchText)
}
